export const state_data = {
  "Alabama": { population: 5024279, capital: "Montgomery", region: "South" },
  "Alaska": { population: 733391, capital: "Juneau", region: "West" },
  "Arizona": { population: 7151502, capital: "Phoenix", region: "West" },
  "Arkansas": { population: 3011524, capital: "Little Rock", region: "South" },
  "California": { population: 39538223, capital: "Sacramento", region: "West" },
  "Colorado": { population: 5773714, capital: "Denver", region: "West" },
  "Connecticut": { population: 3605944, capital: "Hartford", region: "Northeast" },
  "Delaware": { population: 989948, capital: "Dover", region: "South" },
  "Florida": { population: 21538187, capital: "Tallahassee", region: "South" },
  "Georgia": { population: 10711908, capital: "Atlanta", region: "South" },
  "Hawaii": { population: 1455271, capital: "Honolulu", region: "West" },
  "Idaho": { population: 1839106, capital: "Boise", region: "West" },
  "Illinois": { population: 12812508, capital: "Springfield", region: "Midwest" },
  "Indiana": { population: 6785528, capital: "Indianapolis", region: "Midwest" },
  "Iowa": { population: 3190369, capital: "Des Moines", region: "Midwest" },
  "Kansas": { population: 2937880, capital: "Topeka", region: "Midwest" },
  "Kentucky": { population: 4505836, capital: "Frankfort", region: "South" },
  "Louisiana": { population: 4657757, capital: "Baton Rouge", region: "South" },
  "Maine": { population: 1362359, capital: "Augusta", region: "Northeast" },
  "Maryland": { population: 6177224, capital: "Annapolis", region: "South" },
  "Massachusetts": { population: 7029917, capital: "Boston", region: "Northeast" },
  "Michigan": { population: 10077331, capital: "Lansing", region: "Midwest" },
  "Minnesota": { population: 5706494, capital: "St. Paul", region: "Midwest" },
  "Mississippi": { population: 2961279, capital: "Jackson", region: "South" },
  "Missouri": { population: 6154913, capital: "Jefferson City", region: "Midwest" },
  "Montana": { population: 1084225, capital: "Helena", region: "West" },
  "Nebraska": { population: 1961504, capital: "Lincoln", region: "Midwest" },
  "Nevada": { population: 3104614, capital: "Carson City", region: "West" },
  "New Hampshire": { population: 1377529, capital: "Concord", region: "Northeast" },
  "New Jersey": { population: 9288994, capital: "Trenton", region: "Northeast" },
  "New Mexico": { population: 2117522, capital: "Santa Fe", region: "West" },
  "New York": { population: 20201249, capital: "Albany", region: "Northeast" },
  "North Carolina": { population: 10439388, capital: "Raleigh", region: "South" },
  "North Dakota": { population: 779094, capital: "Bismarck", region: "Midwest" },
  "Ohio": { population: 11799448, capital: "Columbus", region: "Midwest" },
  "Oklahoma": { population: 3959353, capital: "Oklahoma City", region: "South" },
  "Oregon": { population: 4237256, capital: "Salem", region: "West" },
  "Pennsylvania": { population: 13002700, capital: "Harrisburg", region: "Northeast" },
  "Rhode Island": { population: 1097379, capital: "Providence", region: "Northeast" },
  "South Carolina": { population: 5118425, capital: "Columbia", region: "South" },
  "South Dakota": { population: 886667, capital: "Pierre", region: "Midwest" },
  "Tennessee": { population: 6910840, capital: "Nashville", region: "South" },
  "Texas": { population: 29145505, capital: "Austin", region: "South" },
  "Utah": { population: 3271616, capital: "Salt Lake City", region: "West" },
  "Vermont": { population: 643077, capital: "Montpelier", region: "Northeast" },
  "Virginia": { population: 8631393, capital: "Richmond", region: "South" },
  "Washington": { population: 7705281, capital: "Olympia", region: "West" },
  "West Virginia": { population: 1793716, capital: "Charleston", region: "South" },
  "Wisconsin": { population: 5893718, capital: "Madison", region: "Midwest" },
  "Wyoming": { population: 576851, capital: "Cheyenne", region: "West" },
  "District of Columbia": { population: 689545, capital: "Washington", region: "South" },
  "Puerto Rico": { population: 3285874, capital: "San Juan", region: "Territory" },
  "Guam": { population: 168485, capital: "Hagåtña", region: "Territory" },
  "U.S. Virgin Islands": { population: 106977, capital: "Charlotte Amalie", region: "Territory" },
  "Northern Mariana Islands": { population: 57559, capital: "Saipan", region: "Territory" },
  "American Samoa": { population: 55519, capital: "Pago Pago", region: "Territory" }
};